import { IconNames } from '@blueprintjs/icons';
import { MessagingBlock } from '@strata/react-messaging-block';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const getStatus = (sentToPharmacy, officeManaged) => {
    if (officeManaged) {
        return MessagingBlock.Status.DEFAULT;
    }
    if (!sentToPharmacy) {
        return MessagingBlock.Status.SUCCESS;
    }
    return MessagingBlock.Status.ERROR;
};

const getReferralSubmissionMessage = (sentToPharmacy, pharmacyCount, officeManaged) => {
    if (officeManaged) {
        return 'The authorization will be submitted to the payer, and the prescription should be sent to an in-network pharmacy of your choice.';
    }

    if (!sentToPharmacy) {
        let pharmacyText = 'An authorized pharmacy';
        if (pharmacyCount === 1) {
            pharmacyText = 'The authorized pharmacy';
        } else if (pharmacyCount > 1 && pharmacyCount <= 10) {
            pharmacyText = 'One of the authorized pharmacies';
        }
        return `${pharmacyText} will contact you to verify the referral information. Please refrain from sending the prescription until the pharmacy makes contact with your office.`;
    }

    return `${
        pharmacyCount > 10 || pharmacyCount === 0
            ? "The patient's insurance plan has not yet assigned an authorized pharmacy for this referral. "
            : ''
    }Let us know where you sent the prescription and Free Market Health will help connect the dots.`;
};
export const ReferralSubmissionMessageContainer = ({
    sentToPharmacy = false,
    pharmacyCount = 0,
    officeManaged = false,
}) => (
    <MessagingBlock
        className={classNames(
            'rta_referral-submission__message-container',
            'margin__left--x-large',
            'padding__around--large',
            'text-align--left',
        )}
        size={MessagingBlock.Sizes.MEDIUM}
        icon={sentToPharmacy ? IconNames.ERROR : IconNames.ENDORSED}
        iconSize={100}
        iconStatus={getStatus(sentToPharmacy, officeManaged)}
        primaryText={
            <p
                className={classNames({
                    [`rta_referral-submission__message-container__header--${
                        !sentToPharmacy ? 'success' : 'error'
                    }`]: !officeManaged,
                })}
            >
                {getReferralSubmissionMessage(sentToPharmacy, pharmacyCount, officeManaged)}
            </p>
        }
        secondaryText={
            !officeManaged && (
                <>
                    <p>For your submitted referrals, we&apos;ll make sure:</p>
                    <ul>
                        <li>
                            They get reviewed by the payer and that you have a real-time view into
                            the status.
                        </li>
                        <li>
                            Your patient gets connected to a specialty drug provider authorized by
                            the payer and well suited for their care needs.
                        </li>
                        <li>
                            The authorized pharmacy contacts you to verify and obtain the official
                            prescription.
                        </li>
                    </ul>
                </>
            )
        }
    />
);

ReferralSubmissionMessageContainer.propTypes = {
    sentToPharmacy: PropTypes.bool,
    pharmacyCount: PropTypes.number,
    officeManaged: PropTypes.bool,
};
